import { useQuery } from 'react-query';
import { apiResponseWrapper } from 'utils/apiResponseWrapper';
import { getTaxesCards } from '../components/TaxesDetailNew/TaxesServices';

export const useTaxCards = (options) => {
  const childInn = options?.childInn;
  const parentTax = options?.parentTax;

  const queryKey = ['getTaxesCards'];

  if (parentTax) {
    queryKey.push(`parentTax:${parentTax}`);
  }

  if (childInn) {
    queryKey.push(`childInn:${childInn}`);
  }

  return useQuery(queryKey, async () => {
    const res = await getTaxesCards({ childInn, parentTax });
    return apiResponseWrapper(res);
  });
};
